import type { ArcLinkProps } from "@majitap/ui";
import { useRouter } from "@tanstack/react-router";

/**
 * The link Arc and @majitap/ui render, set once with ArcProvider: a real <a href> that the
 * router handles in place. Modified clicks (new tab, new window) and other targets stay the
 * browser's.
 */
export function RouterLink({ href, onClick, target, ...props }: ArcLinkProps) {
  const router = useRouter();
  return (
    <a
      {...props}
      href={href}
      target={target}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented || event.button !== 0 || target) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        void router.navigate({ href });
      }}
    />
  );
}
